import { userConstants } from "../../constant";


  
  export function removeDataReducer(state = {}, action) {
    switch (action.type) {
      case userConstants.REMOVEDATA:
        return {
          removeData: action.removeData,
        };
      default:
        return state;
    }
  }